/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://6hhrnmdwm5gjnaqnf2hgkdo5xq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-djq7nemcmzdjvgogreyqko5fiy",
    "aws_cognito_identity_pool_id": "us-east-1:bdb833da-1819-47ab-b5a2-8714bc1b7654",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_BGpaQyqHl",
    "aws_user_pools_web_client_id": "1vhf0pv7p91tuhfst61i9l1lp",
    "oauth": {
        domain: "gvation.auth.us-east-1.amazoncognito.com",
      scope: ["email","openid","profile","aws.cognito.signin.user.admin"],
      redirectSignIn: "http://localhost:3000",
      redirectSignOut: "config.AWS_COGNITO_IDP_SIGNOUT_URL",
      responseType: "token"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
